import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { finishSession } from '~/gen/proto/bff/v1/common-BffCommonService_connectquery'
import { BffCommonService } from '~/gen/proto/bff/v1/common_pb'

export function useFinishSession(): ReturnType<typeof useMutation> {
  const queryClient = useQueryClient()

  return useMutation(finishSession, {
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: BffCommonService.method.listSessions,
          cardinality: 'finite',
        }),
      })
    },
  })
}
